import { render, staticRenderFns } from "./PainelAginova.vue?vue&type=template&id=03dfc0c6"
import script from "./PainelAginova.vue?vue&type=script&lang=js"
export * from "./PainelAginova.vue?vue&type=script&lang=js"
import style0 from "./PainelAginova.vue?vue&type=style&index=0&id=03dfc0c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports